export const MESSAGE_CREATIVE_MADE_SOUND = "CREATIVE_MADE_SOUND";
export const MESSAGE_TOGGLE_MUTED = "TOGGLE_MUTED";
export const MESSAGE_INTERACTION_CHANGE = "INTERACTION_CHANGE";
export const MESSAGE_CLICKTHROUGH = "CLICKTHROUGH";
export const MESSAGE_MRAID_EVENT = "MRAID_EVENT";
export const MESSAGE_MRAID_CALL = "MRAID_CALL";
export const MESSAGE_UPDATED_MRAID_PROPERTIES = "UPDATED_MRAID_PROPERTIES";
export const MESSAGE_INNER_ENV_INIT_COMPLETE = "INNER_ENV_INIT_COMPLETE";
export const MESSAGE_OUTER_ENV_INIT_COMPLETE = "OUTER_ENV_INIT_COMPLETE";
export const MESSAGE_REQUEST_DOM_SNAPSHOT = "REQUEST_DOM_SNAPSHOT";
export const MESSAGE_DOM_SNAPSHOT = "DOM_SNAPSHOT";
export const MESSAGE_INNER_ENV_ERROR = "INNER_ENV_ERROR";
export const MESSAGE_RESIZE = "RESIZE";

// External Messages from Vungle.
export const MESSAGE_VUNGLE_CLICKTHROUGH = "download";

// External Messages from Tresensa creatives.
export const MESSAGE_TRESENSA_INTERACTION = "tre_interaction";



// WEBPACK FOOTER //
// ./src/js/madlib/csp-env/messages.js